
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function StockAutocomplete(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [aukey, setAuKey] = React.useState(false);

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const oninput = (event, value, reason) => {
    if ((isNumeric(value) && value.length > 1) || (!isNumeric(value) && value.length > 0)) {
      fetch("/jstock/v1/stock/searchcom?key=" + value)
        .then(res => res.json())
        .then(
          result => {
            setOptions(result);
          });
    }
  }

  const onclose = (event, reason) => {
    setOpen(false);
  }

  const onchange = (event, value) => {
    if (value != null) {
      props.menuChange(value.value)
      setAuKey(!aukey)
    }
  }


  return (
    <Autocomplete
      id="stock input"
      key={aukey}
      style={{ minWidth: 280, width: '100%'}}
      open={open}
      onInputChange={oninput}
      onOpen={() => {
        setOpen(true);
      }}
      freeSolo
      onChange={onchange}
      onClose={onclose}
      getOptionSelected={(option, value) => option.name === value.name}
      getOptionLabel={option => option.label}
      options={options}
      size = 'small'
      noOptionsText=""
      renderInput={params => (
        <TextField
        style={{ marginTop: 10, marginBottom: 10}}
          {...params}
          fullWidth
          variant="outlined"
          placeholder="股票代號或名稱"
          InputProps={{
            ...params.InputProps,
            style: {padding: 8}
          }}

        />
      )}
    />
  );
}
